import React, { useState } from 'react'

export default function SendReportModal({primaryEmail, handleSubmit, close, saving}) {
    const [email, setEmail] = useState(primaryEmail)
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Send Report CSV To Email</h4>

                <div className='row text-left'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='name'>Email Address</label>
                            <input type='email' step="1" className='form-control' name='email' id='email' placeholder='example@mail.com' 
                                value={email} onChange={(event) => setEmail(event.target.value)}
                            />
                            <small>
                                Your primary email is prefilled but you can send to another email but be careful not to send to a wrong email
                            </small>
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => handleSubmit(email)} type="button" className="btn btn-primary mr-2" disabled={!email || saving}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Send Report
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
